/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsCreateSupportToken
 */
export interface MelcoModelsCreateSupportToken {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCreateSupportToken
     */
    for_user?: string | null;
}

export function MelcoModelsCreateSupportTokenFromJSON(json: any): MelcoModelsCreateSupportToken {
    return MelcoModelsCreateSupportTokenFromJSONTyped(json, false);
}

export function MelcoModelsCreateSupportTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsCreateSupportToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'for_user': !exists(json, 'for_user') ? undefined : json['for_user'],
    };
}

export function MelcoModelsCreateSupportTokenToJSON(value?: MelcoModelsCreateSupportToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'for_user': value.for_user,
    };
}


